export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 60 }, 
  { key: '2', headerName: 'Category', field: 'category', hide: false, width: 200 },
  { key: '3', headerName: 'SubCategory', field: 'subcategory', hide: false, width: 250 },
  { key: '4', headerName: 'Points', field: 'point', hide: false, width: 300 },
  { key: '5', headerName: 'Score', field: 'score', hide: false, width: 100 },
  { key: '6', headerName: 'Department', field: 'department', hide: false, width: 180 },
  { key: '7', headerName: 'Status', field: 'status', hide: false, width: 120 }
];
